import { useSyncExternalStore } from "react"

const noSubscribe = () => () => {}
const afterHydration = () => true
const duringHydration = () => false

/**
 * False on the server and while React hydrates server HTML; true from the
 * render right after hydration on, and from the first render of a tree that
 * mounts without hydrating (a soft navigation). The one primitive for "does
 * this render have to match the server HTML": gate on it instead of a mount
 * flag in an effect or a copy of this snapshot.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(noSubscribe, afterHydration, duringHydration)
}
